module.exports = __webpack_public_path__ + "static/media/ios-rocket.92cc6ee9.svg";